/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import AuswertungenConstants from "../AuswertungenConstants";
import AppRouterDefinition from "./../../../AppRouterDefinition";
import VertialSplit from "./../../../Basis/Components/VerticalSplit";
const AuswertungenView = React.lazy(() => import(/* webpackChunkName: "Auswertungen" */ "../Views/AuswertungenView"));
const AuswertungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Auswertungen" */ "./../Components/AuswertungenBreadcrumb"));
const AuswertungBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Auswertungen" */ "./../Components/AuswertungBreadcrumb"));
const AuswertungReportBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Auswertungen" */ "./../Components/AuswertungReportBreadcrumb"));
const AuswertungenNavigationView = React.lazy(() => import(/* webpackChunkName: "Auswertungen" */ "../Views/AuswertungenNavigationView"));
const AuswertungView = React.lazy(() => import(/* webpackChunkName: "Auswertungen" */ "../Views/AuswertungView"));
const ReportView = React.lazy(() => import(/* webpackChunkName: "Auswertungen" */ "../Views/ReportView"));
const AuswertungBelegeFilterView = React.lazy(() => import(/* webpackChunkName: "Auswertungen" */ "../Views/AuswertungBelegeFilterView"));
const AuswertungSeminarRessourcenBelegungenFilterView = React.lazy(() => import(/* webpackChunkName: "Auswertungen" */ "../Views/AuswertungSeminarRessourcenBelegungenFilterView"));
const AuswertungFragebogenFilterView = React.lazy(() => import(/* webpackChunkName: "Auswertungen" */ "../Views/AuswertungFragebogenFilterView"));

const AUSWERTUNGPATH = "/auswertung/:auswertungId";

export const auswertungenRouterDefinitions: Array<AppRouterDefinition> = [
    {
        path: "/auswertungen",
        render: (renderProps: any) => <AuswertungenView {...renderProps} />,
        createBreadcrumbs: () => [<AuswertungenBreadcrumb />],
    },
    {
        path: AUSWERTUNGPATH,
        render: (renderProps: any) => (
            <VertialSplit
                left={() => <AuswertungenNavigationView {...renderProps} />}
                right={() => <AuswertungView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (createProps: any) => [
            <AuswertungenBreadcrumb />,
            <AuswertungBreadcrumb auswertungId={createProps.auswertungId} />,
        ],
    },
    {
        exact: true,
        path: `/auswertung/${AuswertungenConstants.auswertungBelegeId}`,
        parentPath: AUSWERTUNGPATH,
        render: (renderProps: any) => <AuswertungBelegeFilterView {...renderProps} />,
        createBreadcrumbs: () => [
            <AuswertungenBreadcrumb />,
            <AuswertungBreadcrumb auswertungId={AuswertungenConstants.auswertungBelegeId} />,
        ],
    },
    {
        exact: true,
        path: `/auswertung/${AuswertungenConstants.auswertungSeminarRessourcenBelegungenId}`,
        parentPath: AUSWERTUNGPATH,
        render: (renderProps: any) => <AuswertungSeminarRessourcenBelegungenFilterView {...renderProps} />,
        createBreadcrumbs: () => [
            <AuswertungenBreadcrumb />,
            <AuswertungBreadcrumb auswertungId={AuswertungenConstants.auswertungSeminarRessourcenBelegungenId} />,
        ],
    },
    {
        exact: true,
        path: `/auswertung/${AuswertungenConstants.auswertungFragebogenId}`,
        parentPath: AUSWERTUNGPATH,
        render: (renderProps: any) => <AuswertungFragebogenFilterView {...renderProps} />,
        createBreadcrumbs: () => [
            <AuswertungenBreadcrumb />,
            <AuswertungBreadcrumb auswertungId={AuswertungenConstants.auswertungFragebogenId} />,
        ],
    },
    {
        path: "/auswertung/:auswertungId/report/:blobId",
        parentPath: AUSWERTUNGPATH,
        exact: true,
        render: (renderProps: any) => <ReportView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <AuswertungenBreadcrumb />,
            <AuswertungBreadcrumb auswertungId={createProps.auswertungId} />,
            <AuswertungReportBreadcrumb
                auswertungId={createProps.auswertungId}
                blobId={createProps.blobId}
            />,
        ],
    },
];
